// components/search-bar.tsx
import { Paper, IconButton, InputBase } from '@mui/material'
import type { SxProps, Theme } from '@mui/material/styles'
import SearchIcon from '@mui/icons-material/Search'
import CloseIcon from '@mui/icons-material/Close'

interface SearchBarProps {
  value: string
  placeholder?: string
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  onSearch: () => void
  onClear: () => void
  sx?: SxProps<Theme>         
}

export const SearchBar = ({
  value,
  placeholder = 'Cerca …',
  onChange,
  onSearch,
  onClear,
  sx
}: SearchBarProps) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event)
    if (!event.target.value.trim()) {
      onClear()
    }
  }

  return (
    <Paper
      component="form"
      elevation={0}
      sx={{
        height: 40,
        display: 'flex',
        alignItems: 'center',
        border: '1px solid',
        borderColor: 'grey.400',
        pl: 1,
        pr: 0.5,
        width: 320,
        float: 'right',
        ...sx
      }}
      onSubmit={(event) => {
        event.preventDefault()
        if (value) onSearch()
      }}
    >
      <IconButton
        size="small"
        sx={{ color: 'grey.700' }}
        onClick={(event) => {
          event.preventDefault()
          if (value) onSearch()
        }}
      >
        <SearchIcon fontSize="small" />
      </IconButton>

      <InputBase
        value={value}
        onChange={handleChange}
        placeholder={placeholder}
        sx={{ flex: 1, fontSize: '0.95rem', ml: 1 }}
        inputProps={{ 'aria-label': 'Cerca' }}
        onKeyDown={(event) => {
          if (event.key === 'Enter') {
            event.preventDefault()
            if (value) onSearch()
          }
        }}
      />

      {value && (
        <IconButton
          size="small"
          sx={{ color: 'grey.600' }}
          onClick={(event) => {
            event.preventDefault()
            onClear()
          }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      )}
    </Paper>
  )
}